import { ErrorHandler, Injectable } from '@angular/core'

// Lazy route chunks failing after a deploy: webpack, esbuild (Chrome), Safari and Firefox wordings
const CHUNK_LOAD_FAILED = /Loading chunk [\s\S]*? failed|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/
// The Google Translate extension rewrites the DOM and breaks event targets
// https://github.com/getsentry/sentry/pull/10153
const GOOGLE_TRANSLATE_ERROR = /a\[b\]\.target\.className\.indexOf is not a function/
const RELOAD_FLAG = 'mmx-chunk-reload-at'
const RELOAD_COOLDOWN_MS = 60_000

@Injectable()
export class GeneralErrorHandler extends ErrorHandler {
  override handleError(error: any): void {
    const message = String(error?.message ?? error ?? '')

    if (CHUNK_LOAD_FAILED.test(message) && this.reloadOnce()) {
      return
    }

    if (GOOGLE_TRANSLATE_ERROR.test(message)) {
      return
    }

    super.handleError(error)
  }

  // The browser cached the previous bundle; one reload fetches the new chunks. Never loop on it.
  private reloadOnce(): boolean {
    try {
      const last = Number(sessionStorage.getItem(RELOAD_FLAG) ?? 0)
      if (Date.now() - last < RELOAD_COOLDOWN_MS) {
        return false
      }
      sessionStorage.setItem(RELOAD_FLAG, String(Date.now()))
      window.location.reload()
      return true
    } catch {
      return false
    }
  }
}
